import { render, staticRenderFns } from "./customerGroups.vue?vue&type=template&id=46a848f9&scoped=true"
import script from "./customerGroups.vue?vue&type=script&lang=js"
export * from "./customerGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a848f9",
  null
  
)

export default component.exports